module.exports = __webpack_public_path__ + "img/roja.428c37e0.gif";